










































































































































































































































































































































































































































































































































































import {
  CarpCategoryCarpCategoryDTO,
  CarpCategoryCarpSubCategoryDTO,
  CarpCategoryListSubCategoryRequest,
  CarpCategoryManagerService,
  CarpsaleManagementCarpsaleService,
  CarpsaleManagementCreateItemRequest,
  CarpsaleManagementEditItemQuantityRequest,
  CarpsaleManagementEditItemRequest,
  SettingManagementCreateSettingRequest,
  StoreManagementSaleDTO,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import EditOptionComponent from "@/components/admin/store/common/editOptionComponent.vue";
import EditSaleItemsComponent from "@/components/admin/store/common/editSaleItemsComponent.vue";
import LanguageComponent from "@/components/common/languageComponent.vue";
import QEditor from "@/components/common/qEditor.vue";
import QInput from "@/components/common/qInput.vue";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import QInputNumber from "@/components/common/qInputNumber.vue";
import QLanguageTab from "@/components/common/qLanguageTab.vue";
import QReleaseSettingStore from "@/components/common/qReleaseSettingStore.vue";
import QSelect from "@/components/common/qSelect.vue";
import _ from "lodash";
import { error } from "logrocket";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const storeX = namespace("Store");

@Component({
  name: "CarpsaleEditComponent",
  methods: { error },
  computed: {
    CarpsaleManagementCreateItemRequest() {
      return CarpsaleManagementCreateItemRequest;
    },
    SettingManagementCreateSettingRequest() {
      return SettingManagementCreateSettingRequest;
    },
  },
  components: {
    EditOptionComponent,
    EditSaleItemsComponent,
    LanguageComponent,
    QCalendar,
    QEditor,
    QErrors,
    QInput,
    QInputMultipleLanguage,
    QInputNumber,
    QLanguageTab,
    QReleaseSettingStore,
    QSelect,
  },
})
export default class CarpsaleEditComponent extends Vue {

  get contextLangList() {
    const langEn = this.languages.en;
    const langCn = this.languages.cn;

    return [...[LANG.JA], ...(langEn ? ["en"] : []), ...(langCn ? ["cn"] : [])];
  }

  get contentLanguageComputed() {
    if (this.languages[this.contentLanguage] === true) {
      return this.contentLanguage;
    } else {
      return "ja";
    }
  }
  public title = "錦鯉販売の新規作成";
  public errors = {};
  public languages = {
    ja: true,
    en: true,
    cn: false,
  };
  public startDate = null;
  public endDate = null;

  public categories: CarpCategoryCarpCategoryDTO[] = [];
  public subCategories: CarpCategoryCarpSubCategoryDTO[] = [];
  public sales: StoreManagementSaleDTO[] = [];

  public item = {
    id: null,
    categoryId: null,
    subCategoryId: null,
    code: null,
    type: CarpsaleManagementCreateItemRequest.type.BOTH,
    language: CarpsaleManagementCreateItemRequest.language.ALL,
    name: null,
    nameEn: null,
    nameCn: null,
    optionNames: [],
    optionNamesEn: [],
    optionNamesCn: [],
    company: null,
    companyEn: null,
    companyCn: null,
    kind: null,
    kindEn: null,
    kindCn: null,
    sex: null,
    isPrice: false,
    price: null,
    salePrice: null,
    isQuantity: true,
    quantity: 1,
    size: null,
    sendType: CarpsaleManagementCreateItemRequest.sendType.SINGLE,
    context: "",
    contextEn: null,
    contextCn: null,
    startSaleDatetime: null,
    openStatus: CarpsaleManagementCreateItemRequest.openStatus.HOLD,
    releaseSetting: null,
    postDate: null,
    saleId: null,
    images: [],
    saleCode: null,
    startDate: null,
    endDate: null,
  };

  public single = CarpsaleManagementCreateItemRequest.sendType.SINGLE;
  public multi = CarpsaleManagementCreateItemRequest.sendType.MULTI;

  public origin;

  public isEditing = false;

  public dateConfig = {
    dateFormat: "Y-m-d",
    enableTime: false,
    allowInput: false,
  };

  public quantity = 0;
  public isShowQuantity = false;

  public localStartDate = null;
  public localPostHours = null;
  public localPostMinute = null;

  public isLoadingSubCategories = false;

  public isRequiredSubCategory = false;

  public contentLanguage = "ja";

  @storeX.Action
  public updateItem!: (live) => void;

  public async mounted() {
    const id = Number(this.$router.currentRoute.params.id);
    if (!id) {
      this.origin = _.cloneDeep(this.item);
    }
  }

  public created() {
    this.getCategories();

    const id = Number(this.$router.currentRoute.params.id);
    if (id) {
      this.isEditing = true;
      this.getDetail(id).then(() => {
        this.getSubCategories();
      });
    }

    this.getSales();
  }

  public async getDetail(id) {
    try {
      const {
        data,
      } = await CarpsaleManagementCarpsaleService.adminCarpsaleView({
        id,
      });

      this.item = {
        id: data.item.id,
        categoryId: data.item.carp_category_id,
        subCategoryId: data.item.carp_sub_category_id,
        code: data.item.code,
        type: data.item.type as CarpsaleManagementCreateItemRequest.type,
        language: data.item
          .language as CarpsaleManagementCreateItemRequest.language,
        name: data.item.name,
        nameEn: data.item.name_en,
        nameCn: data.item.name_cn,
        optionNames: data.item.option_names
          ? data.item.option_names.split("|")
          : null,
        optionNamesEn: data.item.option_names_en
          ? data.item.option_names_en.split("|")
          : null,
        optionNamesCn: data.item.option_names_cn
          ? data.item.option_names_cn.split("|")
          : null,
        company: data.item.company,
        companyEn: data.item.company_en,
        companyCn: data.item.company_cn,
        kind: data.item.kind,
        kindEn: data.item.kind_en,
        kindCn: data.item.kind_cn,
        sex: data.item.sex,
        isPrice: data.item.is_price,
        price: data.item.price,
        salePrice: data.item.sale_price,
        isQuantity: data.item.is_quantity,
        startSaleDatetime: data.item.start_sale_datetime,
        quantity: data.item.quantity,
        size: data.item.size,
        sendType: data.item
          .send_type as CarpsaleManagementCreateItemRequest.sendType,
        context: data.item.context,
        contextEn: data.item.context_en,
        contextCn: data.item.context_cn,
        openStatus: data.item
          .open_status as CarpsaleManagementCreateItemRequest.openStatus,
        releaseSetting: data.item.release_setting,
        postDate: data.item.post_date,
        saleId: data.item.sale_id,
        images: data.item.images,
        saleCode: null,
        startDate: null,
        endDate: null,
      };

      this.changeStartSaleDate();
      this.title = data.item.name + "の編集";
      this.origin = _.cloneDeep(this.item);
      this.quantity = data.item.quantity;
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });

      await this.$router.push({ name: "notFound" });
    }
  }

  public async getCategories() {
    const result = await CarpCategoryManagerService.adminCarpCategory({});
    this.categories = result.data.carp_categories;
  }

  public async getSales() {
    const result = await CarpsaleManagementCarpsaleService.adminCarpsaleListSale(
      {},
    );
    this.sales = result.data.sales;
  }

  public changeCategory() {
    this.item.subCategoryId = null;
    this.subCategories = [];
    this.getSubCategories();
  }

  public changeSubCategory() {
    if (this.item.subCategoryId == "null") {
      this.item.subCategoryId = null;
    }
  }

  public validateQuantity() {
    const stringQuantity = this.item.quantity.toString();
    const result = stringQuantity.replace(/\D/g, "");
    this.item.quantity = Number.parseInt(result);
  }

  public changeQuantity() {
    if (!this.item.isQuantity) {
      this.item.quantity = null;
    }
  }

  public async getSubCategories() {
    if (this.item.categoryId) {
      this.isLoadingSubCategories = true;
      const result = await CarpCategoryManagerService.adminCarpSubCategory({
        categories: [this.item.categoryId],
        disabledLoadinng: true,
      } as CarpCategoryListSubCategoryRequest);
      this.subCategories = result.data.carp_sub_categories;
      this.isRequiredSubCategory = this.subCategories.length > 0;
      this.isLoadingSubCategories = false;
    }
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      onConfirm: () => {
        this.delete();
      },
      onClose: () => {
        //
      },
    });
  }

  public confirmCancel() {
    if (_.isEqual(this.item, this.origin)) {
      this.$router.back();
    } else {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.back();
        },
        onClose: () => {
          //
        },
      });
    }
  }

  public async submit() {
    this.errors = {};
    let result;

    try {
      if (!this.isEditing) {
        result = await CarpsaleManagementCarpsaleService.adminCarpsaleCreate(
          this.item as CarpsaleManagementCreateItemRequest,
        );
      } else {
        result = await CarpsaleManagementCarpsaleService.adminCarpsaleEdit(
          this.item as CarpsaleManagementEditItemRequest,
        );
      }

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });

        await this.$router.back();
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
        if ("context" in this.errors) {
          this.contentLanguage = LANG.JA;
        } else if ("contextEn" in this.errors) {
          this.contentLanguage = LANG.EN;
        } else if ("contextCn" in this.errors) {
          this.contentLanguage = LANG.CN;
        }
      }
    }
  }

  public async submitQuantity() {
    CarpsaleManagementCarpsaleService.adminCarpsaleEditQuantity({
      id: this.item.id,
      quantity: this.quantity,
    } as CarpsaleManagementEditItemQuantityRequest)
      .then((data) => {
        this.isShowQuantity = false;
        qNotify.success({
          text: "在庫数を更新しました。",
        });
        this.item.quantity = data.data.item.quantity;
        this.quantity = data.data.item.quantity;
      })
      .catch((error) => {
        qNotify.error({
          text: error.body.message,
        });
        this.errors = error.body.errors;
      })
      .finally(() => {
        // none
      });
  }

  public async delete() {
    this.errors = {};

    try {
      const result = await CarpsaleManagementCarpsaleService.adminCarpsaleDelete({
        id: this.item.id,
      });

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });

        await this.$router.back();
      }
    } catch (error) {
      const result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public preview() {
    this.updateItem(_.cloneDeep(this.item));
    window.open("/carpsale/preview", "_blank");
  }

  public editQuantity() {
    this.isShowQuantity = true;
  }

  public cancelQuantityPopup() {
    this.isShowQuantity = false;
  }

  public capitalizeLang(lang) {
    return _.capitalize(lang);
  }

  public changeStartSaleDate(): void {
    if (this.item.startSaleDatetime) {
      const postDate = new Date(this.item.startSaleDatetime);
      this.localStartDate = moment(postDate.toUTCString()).format("YYYY-MM-DD");
      this.localPostHours = postDate.getHours();
      this.localPostMinute = postDate.getMinutes();
    } else {
      this.localStartDate = null;
      this.localPostHours = null;
      this.localPostMinute = null;
    }
  }

  public changeLocalStartSaleDate(): void {
    let startTime = null;
    if (this.localStartDate) {
      this.localPostHours = Math.min(Math.max(0, this.localPostHours), 23);
      this.localPostMinute = Math.min(Math.max(0, this.localPostMinute), 59);
      const hours = this.localPostHours.toString().padStart(2, "0");
      const minutes = this.localPostMinute.toString().padStart(2, "0");
      startTime = moment(`${this.localStartDate} ${hours}:${minutes}`).format(
        "YYYY-MM-DD HH:mm",
      );
    }
    this.item.startSaleDatetime = startTime;
    this.changeInput("startSaleDatetime");
  }
}
